import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('ColorPreview')(({ extColor, intColorImage }) =>
  css({
    display: 'block',
    width: ['280px', '280px', '350px'],
    height: '111px',
    position: 'relative',
    borderRadius: '4px',
    mb: 's',
    background: `linear-gradient(333deg, rgba(0, 0, 0, 0.00) 39.8%, rgba(142, 142, 142, 0.19) 46.12%, rgba(210, 210, 210, 0.29) 56.08%, rgba(255, 255, 255, 0.35) 67.63%, rgba(199, 199, 199, 0.35) 82.97%, rgba(120, 120, 120, 0.35) 93.81%, rgba(44, 39, 44, 0.35) 99.64%), ${extColor}`,
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      borderRadius: '4px',
      backgroundImage: `url(${intColorImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      // clip interior color image diagonally
      clipPath: 'polygon(100% 0, 0% 100%, 100% 100%)',
    },
  }),
);

export default themeStyles;
